{
    "header": "הכנס הזמנה למתפלל"
}